"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgNoDataOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M5.293 6.707a1 1 0 101.414-1.414 1 1 0 00-1.414 1.414z' }),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M20 12.035v-2.034L4 10v4h8.078a2.728 2.728 0 00.029 2.001L4 16v4h8.033a2.739 2.739 0 00.113 2H4c-1.333 0-2-.693-2-2.08V4c0-1.333.667-2 2-2h15.99C21.33 2 22 2.668 22 4v8.147a2.736 2.736 0 00-2-.112zM20 8H4V4l16 .001V8z' }),
    react_1.default.createElement("path", { d: 'M5.293 12.707a1 1 0 101.414-1.414 1 1 0 00-1.414 1.414zM5.293 18.707a1 1 0 101.414-1.414 1 1 0 00-1.414 1.414z' }),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M15.671 14.257l2.243 2.242 2.242-2.242c.464-.48.935-.48 1.415 0s.48.95 0 1.414l-2.243 2.243 2.243 2.242c.471.472.471.943 0 1.415-.472.471-.943.471-1.415 0l-2.242-2.243-2.243 2.243c-.46.482-.932.482-1.414 0-.482-.483-.482-.954 0-1.415l2.242-2.242-2.242-2.243c-.472-.47-.472-.942 0-1.414s.943-.472 1.414 0z' }))); };
exports.default = SvgNoDataOutline;
//# sourceMappingURL=NoDataOutline.js.map